<script>
import ScheduleList from '../SchedulesList'
export default {
  name: 'scheduled-schedules',
  extends: ScheduleList,
  computed: {
    tabSchedule () {
      return this.$store.getters.scheduledSchedule
    }
  },
  mounted () {
    if (this.$store.getters.scheduledSchedule.length === 0) {
      this.$store.dispatch('getScheduledSchedule')
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?f54da8f4